module.exports = __webpack_public_path__ + "static/media/cancel.777c863d.svg";